import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import * as Sentry from '@sentry/react';
import './i18n';
import Router from './router';

import './index.css';

// Configure Sentry.
const sentryEnvs = [
  'production',
  'be.production',
  'staging',
  'be.staging',
  'hk.staging',
  'hk.production',
  'dhsc.staging',
];

if (sentryEnvs.includes(import.meta.env.MODE)) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.5,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
);
